module.exports = __webpack_public_path__ + "img/1.5af23cdc.png";